import { useSelector } from "@tanstack/react-store"
import { createStore } from "@tanstack/store"
import { registerSessionCleanup } from "@/shared/lib/auth"
import {
	DEFAULT_SOCIAL_MATCH_REQUEST_REASON_KIND,
	EMPTY_SOCIAL_MATCH_REQUEST_REASON_TEXTS,
	type SocialMatchRequestReasonKind,
	type SocialMatchRequestReasonTexts,
} from "./request-reasons"

// Черновик формы запроса Social Match. Живёт, пока юзер внутри /social-match:
// «Назад» на приветственный экран и обратно в форму черновик не стирает.
// Стирается после успешной отправки и при выходе из раздела (onLeave роута
// social-match).
export interface SocialMatchRequestDraft {
	requestText: string
	requestReasons: SocialMatchRequestReasonTexts
	// «— Убрать» только прячет блок: тексты остаются, но в запрос не идут.
	requestReasonsOpen: boolean
	activeRequestReason: SocialMatchRequestReasonKind
	profileExpertiseDismissed: boolean
}

const EMPTY_DRAFT: SocialMatchRequestDraft = {
	requestText: "",
	requestReasons: EMPTY_SOCIAL_MATCH_REQUEST_REASON_TEXTS,
	requestReasonsOpen: false,
	activeRequestReason: DEFAULT_SOCIAL_MATCH_REQUEST_REASON_KIND,
	profileExpertiseDismissed: false,
}

const requestDraftStore = createStore<SocialMatchRequestDraft>(EMPTY_DRAFT)

export function useSocialMatchRequestDraft(): SocialMatchRequestDraft {
	return useSelector(requestDraftStore)
}

export function updateSocialMatchRequestDraft(
	patch: Partial<SocialMatchRequestDraft>,
): void {
	requestDraftStore.setState((draft) => ({ ...draft, ...patch }))
}

export function setSocialMatchRequestReason(
	kind: SocialMatchRequestReasonKind,
	value: string,
): void {
	requestDraftStore.setState((draft) => ({
		...draft,
		requestReasons: { ...draft.requestReasons, [kind]: value },
	}))
}

export function clearSocialMatchRequestDraft(): void {
	requestDraftStore.setState(() => EMPTY_DRAFT)
}

registerSessionCleanup(clearSocialMatchRequestDraft)
